export default {
    setSurveyId(state,val) {
        state.su2SurveyId = val;
    },
    setSurveyToken(state,val) {
        state.su2SurveyToken = val;
    }
}
